<div class="empty card" [class.schedule]="type === 'schedule'">
  <div class="empty_wrap">
    <div
      class="empty_img"
      *ngIf="!withoutImg"
    >
      <img [src]="'empty_consultation.svg' | imagePath" alt="empty">
    </div>

    <span class="title">{{ title | translate }}</span>

    <div class="empty_action" *ngIf="type !== 'base'">
      <button
        *ngIf="type === consultationsStatusesNamesEnum.planned"
        class="btn btn-primary"
        (click)="invitePatient()">
        {{ 'Пригласить' | translate }}
      </button>

      <a
        *ngIf="type === 'schedule'"
        routerLink="/schedule/schedule-board"
        class="btn btn-primary"
      >
        {{ 'Создать расписание' | translate }}
      </a>
    </div>
  </div>
</div>
